import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/45d0854881d907e8cddfcd7aa22fcf03.png"
              alt="Fun Time Photobooths"
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-400 mb-4">
              San Diego's premier provider of overhead 360 video booths and luxury photo booth experiences 
              for weddings, corporate events, and celebrations.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/overhead-360" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Overhead 360
                </Link>
              </li>
              <li>
                <Link to="/photo-booth" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Photo Booth
                </Link>
              </li>
              <li>
                <Link to="/custom-templates" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Custom Templates
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  About
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-orange-500 mt-1"></i>
                <span>San Diego County, CA</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-orange-500 mt-1"></i>
                <a href="tel:+14424160576" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  (442) 416-0576
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-orange-500 mt-1"></i>
                <a href="mailto:luis@funtimephotobooths.com" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  luis@funtimephotobooths.com
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            Copyright © 2026 Fun Time Photobooths Inc. - All Rights Reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-orange-500 text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
